import styled, { createGlobalStyle } from "styled-components";

export const PrimaryColor = "#FFCD00";
export const MaterialCubicBezier = "cubic-bezier(0.4, 0.0, 0.2, 1)";
export const MobileWidth = "767px";
export const SectionPadding = "80px 0 50px";
export const SectionPaddingMobile = "30px 0";

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  width: 100%;

  @media screen and (max-width: ${MobileWidth}) {
    padding: 0 20px;
  }
`;

export const SectionTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
  text-transform: uppercase;
  @media screen and (max-width: ${MobileWidth}) {
    font-size: 20px;
  }

  &.white-font {
    color: #fff;
  }
  &.white-line {
    span:before {
      background-color: #fff;
    }
  }

  span {
    position: relative;
    &:before {
      background-color: ${PrimaryColor};
      border-radius: 8px;
      height: 4px;
      width: 80%;
      content: "";
      position: absolute;
      bottom: -4px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  html {
    scroll-behavior: smooth;
  }
  
  body {
    margin: 0;
    background-color: #000;
    font-family: 'Poppins', sans-serif;
  }
  
  a {
    text-decoration: none;
    transition: all 200ms ${MaterialCubicBezier};
  }
  
  button {
    cursor: pointer;
    font-family: "Poppins", sans-serif;
    outline: 0;
    transition: all 400ms ${MaterialCubicBezier};
  }
`;

export default GlobalStyle;
